import axios from 'axios';

import routes from 'app/routes';

export default {
    getToken: (dispatch) => {
        axios
            .post(routes.api.users.tokens.create)
            .then((response) => {
                dispatch({ type: 'GET_TOKEN', token: response.data.data.token });
            });
    },

    load: (dispatch, token) => {
        axios
            .get(`${gon.ai_rest_api_base_url}/v1/chat/list`, {
                headers: {
                    Authorization: `${token}`,
                },
            },)
            .then((response) => {
                dispatch({ type: 'LOAD', chats: response.data.chats });
            });
    },

    show: (token, chatId, callback) => {
        axios
            .get(
                `${gon.ai_rest_api_base_url}/v1/chat/${chatId}`,
                {
                    headers: {
                        Authorization: `${token}`,
                    },
                },
            )
            .then((response) => {
                callback(response.data);
            });
    }


};
